export enum LandingSiteRouteNames {
  Home = 'home',
  Beauty = 'beauty',
  PrivacyPolicy = 'privacy-policy',
  AppPrivacyPolicy = 'app-privacy-policy',
  TermsOfUse = 'terms-of-use',
  RemoveData = 'remove-data',
  Contact = 'contact',
  Referral = 'join'
}

export enum BusinessV2RouteNames {
  Business = 'business',
  BusinessServices = 'business-services',
  BusinessReviews = 'business-reviews',
  BusinessOverview = 'business-overview',
  BusinessChooseTime = 'business-choose-time',
  BusinessProducts = 'business-products',
  BusinessCheckout = 'business-checkout',
  BusinessConfirmation = 'business-confirmation',
  BusinessProductCheckout = 'business-product-checkout',
  BusinessOrderConfirmation = 'business-order-confirmation',

  AppointmentManagement = 'appointment-management',
  VerifyAppointment = 'verify-appointment',
  VoucherPage = 'voucher',
  PaymentPage = 'p',
  Review = 'review',
  Shop = 'shop',
  JoinLoyaltyProgram = 'loyalty-program',
  ConsentForm = 'consent-form',
  SkinScan = 'skin-scan',
  SkinProgress = 'skin-progress',
}


